export default __webpack_public_path__ + "static/media/slide-3.18bdad28.jpeg";